/* eslint-disable no-underscore-dangle */

import moment from "moment";
import { toThousandSeparatedNumber, joinWithThinSpace } from "../utils";

export const getFormattedDistance = (distance, unit) => joinWithThinSpace(toThousandSeparatedNumber(distance), unit); // "км"

/** @param {moment.Moment} date
 * @param format
 * @param lng
 */
export const getFormattedDate = (date, format, lng) => {
  return moment(date)
    .local()
    .locale(lng)
    .format(format);
};

export const getFormattedPrice = price => {
  return joinWithThinSpace(toThousandSeparatedNumber(price), "₽");
};

export const getFormattedTimeSpan = (durationHours, t) => {
  const daysTranslation = t("trace-common-units-days-abbreviation", "дн");
  const hoursTranslation = t("trace-common-units-hours-abbreviation", "ч");
  const minutesTranslation = t("trace-common-units-minutes-abbreviation", "м");
  
  const time = moment.duration(durationHours, 'hours');
  const hour = time._data.hours;
  const minute = time._data.minutes;
  const day = time._data.days;

  const days = day === 0 ? "" : `${joinWithThinSpace(day, daysTranslation)} `; // "д"
  const hours = hour === 0 ? "" : `${joinWithThinSpace(hour, hoursTranslation)} `; // "ч"
  const minutes = minute === 0 ? "" : `${joinWithThinSpace(minute, minutesTranslation)}`; // "мин"

  return hours === "" && minutes === "" ? `${joinWithThinSpace(0, minutesTranslation)}` : days + hours + minutes;
};
